module.exports = __webpack_public_path__ + "static/img/PaternityTest-01.a9f0ee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paternitytesting/PaternityTest-01.jpg
// module id = 9pJX
// module chunks = 0